<template>
  <div class="relative min-h-full font-sans">

    <!-- ════════════════════════════════════════════
         ÉTAPE 1 — UPLOAD
    ═════════════════════════════════════════════ -->
    <div v-if="step === 'upload'" class="flex flex-col items-center justify-center gap-4">
      <!-- <div class="w-16 h-16 rounded-2xl bg-red-600 flex items-center justify-center text-white text-3xl shadow-lg shadow-red-200 mb-2">
        <i class="fas fa-bolt"></i>
      </div>
      <p class="text-2xl font-bold text-gray-900 m-0">Prêt à saisir</p>
      <p class="text-sm text-gray-400 text-center m-0 leading-relaxed">
        Prends en photo ou importe un document<br>et on s'occupe du reste
      </p> -->
      <div class="w-full">
        <input-file
          key-name="mission_doc"
          accept=".pdf,.png,.jpg,.jpeg"
          :preview="false"
          v-model="documentUrl"
          @input="onDocumentUploaded"
        />
      </div>
      <!-- <button
        class="mt-2 text-xs text-gray-300 underline underline-offset-2 cursor-pointer bg-transparent border-0 p-2"
        @click="step = 'form'"
      >
        Saisir manuellement
      </button> -->
    </div>

    <!-- ════════════════════════════════════════════
         ÉTAPE 2 — SCAN
    ═════════════════════════════════════════════ -->
    <div v-else-if="step === 'scanning'" class="flex flex-col items-center justify-center min-h-[60vh] px-6 gap-6">
      <div class="relative w-20 h-20">
        <div class="absolute inset-0 rounded-full border-4 border-gray-100 border-t-red-600 animate-spin"></div>
        <div class="absolute inset-0 flex items-center justify-center text-red-600 text-2xl">
          <i class="fas fa-file-alt"></i>
        </div>
      </div>
      <p class="text-base font-semibold text-gray-700 m-0">{{ loadingStep }}</p>
      <div class="flex gap-1.5">
        <span
          v-for="i in LOADING_STEPS.length" :key="i"
          class="h-1 rounded-full transition-all duration-500"
          :class="i <= loadingStepIdx + 1 ? 'bg-red-600 w-5' : 'bg-gray-200 w-2'"
        ></span>
      </div>
    </div>

    <!-- ════════════════════════════════════════════
         ÉTAPE 3 — FICHE
    ═════════════════════════════════════════════ -->
    <div v-else-if="step === 'form'" class="flex flex-col gap-3 px-4 pt-4">

      <!-- Banner scan -->
      <div v-if="scanned" class="flex items-center gap-2">
        <button class="text-slate-400 text-xs p-1 bg-transparent border-0 cursor-pointer hover:underline" @click="resetScan">
          <i class="fas fa-redo mr-1"></i> Nouveau document
        </button>
      </div>

      <!-- Fiche -->
      <div class="bg-white rounded-2xl overflow-hidden shadow-sm border">

        <!-- Client -->
        <div
          class="flex items-center gap-3.5 px-4 py-4 cursor-pointer active:bg-gray-50 transition-colors"
          @click="openModal('client')"
        >
          <div
            class="w-10 h-10 rounded-xl flex items-center justify-center text-sm shrink-0"
            :class="hasClient ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-300'"
          >
            <i class="fas fa-user"></i>
          </div>
          <div class="flex flex-col gap-0.5 flex-1 min-w-0">
            <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Client</span>
            <span v-if="hasClient" class="text-base font-semibold text-gray-900 truncate">
              {{ [dataModel.client.prenom, dataModel.client.nom].filter(Boolean).join(' ') }}
              <span v-if="dataModel.client.telephone" class="text-sm font-normal text-gray-400">· {{ dataModel.client.telephone }}</span>
            </span>
            <span v-else class="text-sm italic text-gray-300">Toucher pour ajouter</span>
          </div>
          <i class="fas fa-chevron-right text-gray-200 text-xs shrink-0"></i>
        </div>

        <div class="h-px bg-gray-50 mx-4"></div>

        <!-- Adresse -->
        <div
          class="flex items-center gap-3.5 px-4 py-4 cursor-pointer active:bg-gray-50 transition-colors"
          @click="openModal('adresse')"
        >
          <div
            class="w-10 h-10 rounded-xl flex items-center justify-center text-sm shrink-0"
            :class="hasAdresse ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-300'"
          >
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div class="flex flex-col gap-0.5 flex-1 min-w-0">
            <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Adresse</span>
            <span v-if="hasAdresse" class="text-base font-semibold text-gray-900 truncate">
              {{ dataModel.adresse.adresse1 }}
              <span class="text-sm font-normal text-gray-400">· {{ dataModel.adresse.code_postal }} {{ dataModel.adresse.ville }}</span>
            </span>
            <span v-else class="text-sm italic text-gray-300">Toucher pour ajouter</span>
          </div>
          <i class="fas fa-chevron-right text-gray-200 text-xs shrink-0"></i>
        </div>

        <div class="h-px bg-gray-50 mx-4"></div>

        <!-- Appareil -->
        <div
          class="flex items-center gap-3.5 px-4 py-4 cursor-pointer active:bg-gray-50 transition-colors"
          @click="openModal('appareil')"
        >
          <div
            class="w-10 h-10 rounded-xl flex items-center justify-center text-sm shrink-0"
            :class="dataModel.appareil_type_id ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-300'"
          >
            <i class="fas fa-fire-flame-simple"></i>
          </div>
          <div class="flex flex-col gap-0.5 flex-1 min-w-0">
            <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Appareil</span>
            <span v-if="selectedCategory" class="text-base font-semibold text-gray-900">{{ selectedCategory.label }}</span>
            <span v-else class="text-sm italic text-gray-300">Toucher pour sélectionner</span>
          </div>
          <i class="fas fa-chevron-right text-gray-200 text-xs shrink-0"></i>
        </div>

        <div class="h-px bg-gray-50 mx-4"></div>

        <!-- Intervention -->
        <div
          class="flex items-center gap-3.5 px-4 py-4 cursor-pointer active:bg-gray-50 transition-colors"
          @click="openModal('intervention')"
        >
          <div
            class="w-10 h-10 rounded-xl flex items-center justify-center text-sm shrink-0"
            :class="dataModel.intervention_type_id ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-300'"
          >
            <i class="fas fa-wrench"></i>
          </div>
          <div class="flex flex-col gap-0.5 flex-1 min-w-0">
            <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Intervention</span>
            <span v-if="selectedInterventionType" class="text-base font-semibold text-gray-900">
              {{ selectedInterventionType.nom }}
              <span v-if="dataModel.duree_estimee" class="text-sm font-normal text-gray-400">· {{ formatDuree(dataModel.duree_estimee) }}</span>
            </span>
            <span v-else class="text-sm italic text-gray-300">Toucher pour sélectionner</span>
          </div>
          <i class="fas fa-chevron-right text-gray-200 text-xs shrink-0"></i>
        </div>

        <div class="h-px bg-gray-50 mx-4"></div>

        <!-- Notes -->
        <div class="flex items-start gap-3.5 px-4 py-4">
          <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center text-gray-400 text-sm shrink-0 mt-0.5">
            <i class="fas fa-sticky-note"></i>
          </div>
          <div class="flex flex-col gap-1 flex-1">
            <div class="flex items-center justify-between">
              <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Notes</span>
              <button
                v-if="dataModel.notes_internes"
                class="text-xs text-gray-300 hover:text-red-500 transition-colors bg-transparent border-0 cursor-pointer p-0"
                @click="dataModel.notes_internes = ''"
              >
                <i class="fas fa-times"></i> Effacer
              </button>
            </div>
            <textarea
              v-model="dataModel.notes_internes"
              placeholder="RAS"
              rows="2"
              class="w-full border-0 outline-none bg-transparent text-sm text-gray-700 resize-none placeholder-gray-300 font-sans leading-relaxed p-0"
            ></textarea>
          </div>
        </div>

      </div>

      <!-- CTA fixe -->
      <div class="pt-3">
        <button
          class="w-full py-5 rounded-2xl border-0 text-base font-bold cursor-pointer transition-all duration-150 active:scale-[0.98]"
          :class="canSubmit
            ? 'bg-red-600 hover:bg-red-700 duration-200 text-white shadow-lg shadow-red-200'
            : 'bg-gray-200 text-gray-400 cursor-not-allowed'"
          :disabled="loadingSubmit || !canSubmit"
          @click="submit"
        >
          <i v-if="loadingSubmit" class="fas fa-spinner fa-spin mr-2"></i>
          <template v-else-if="!canSubmit">Ajouter un client pour continuer</template>
          <template v-else><i class="fas fa-check mr-2"></i>Créer l'intervention</template>
        </button>
      </div>

    </div>

    <!-- ════════════════════════════════════════════
         MODALE
    ═════════════════════════════════════════════ -->
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="activeModal"
        class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4"
        @click.self="closeModal"
      >
        <transition
          enter-active-class="transition duration-200 ease-out"
          enter-from-class="opacity-0 scale-95 translate-y-2"
          enter-to-class="opacity-100 scale-100 translate-y-0"
          leave-active-class="transition duration-150 ease-in"
          leave-from-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <div
            v-if="activeModal"
            class="bg-white rounded-3xl w-full max-w-sm sm:max-w-lg shadow-2xl flex flex-col max-h-[85vh]"
          >

            <!-- Header fixe -->
            <div class="flex items-center justify-between px-6 pt-6 pb-4 shrink-0">
              <p class="text-lg font-bold text-gray-900 m-0">{{ modalTitle }}</p>
              <button
                class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 hover:bg-gray-200 transition-colors border-0 cursor-pointer"
                @click="closeModal"
              >
                <i class="fas fa-times text-xs"></i>
              </button>
            </div>

            <!-- Corps scrollable -->
            <div class="overflow-y-auto flex-1 px-6 pb-6 flex flex-col gap-3">

              <!-- ── Client ── -->
              <template v-if="activeModal === 'client'">
                <div class="grid grid-cols-2 gap-3">
                  <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Nom *</label>
                    <input v-model="dataModel.client.nom" type="text" placeholder="Dupont" class="mf-input" />
                  </div>
                  <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Prénom</label>
                    <input v-model="dataModel.client.prenom" type="text" placeholder="Jean" class="mf-input" />
                  </div>
                </div>
                <div class="flex flex-col gap-1.5">
                  <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Téléphone</label>
                  <input v-model="dataModel.client.telephone" type="tel" placeholder="06 12 34 56 78" class="mf-input" />
                </div>
                <div class="flex flex-col gap-1.5">
                  <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Email</label>
                  <input v-model="dataModel.client.email" type="email" placeholder="jean@mail.com" class="mf-input" />
                </div>
                <button
                  class="w-full bg-gray-900 text-white rounded-xl py-3.5 text-sm font-bold border-0 cursor-pointer mt-1 active:bg-gray-700 transition-colors"
                  @click="closeModal"
                >
                  <i class="fas fa-check mr-1.5"></i> Confirmer
                </button>
              </template>

              <!-- ── Adresse ── -->
              <template v-else-if="activeModal === 'adresse'">

                <!-- Recherche autocomplete -->
                <div class="flex flex-col gap-1.5">
                  <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Rechercher</label>
                  <div class="relative">
                    <i class="fas fa-search absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-300 text-sm pointer-events-none"></i>
                    <input
                      v-model="adresseQuery"
                      type="text"
                      placeholder="12 rue des Fleurs, Lyon…"
                      autocomplete="off"
                      class="mf-input pl-10"
                      @input="onAdresseInput"
                      @keydown.down.prevent="adresseMoveDown"
                      @keydown.up.prevent="adresseMoveUp"
                      @keydown.enter.prevent="adresseSelectHighlighted"
                      @keydown.escape="adresseSuggestions = []"
                    />
                    <div v-if="adresseLoading" class="absolute right-3.5 top-1/2 -translate-y-1/2">
                      <div class="w-4 h-4 border-2 border-gray-200 border-t-red-500 rounded-full animate-spin"></div>
                    </div>
                  </div>

                  <!-- Suggestions -->
                  <div v-if="adresseSuggestions.length" class="border border-gray-100 rounded-2xl overflow-hidden shadow-sm">
                    <div
                      v-for="(item, index) in adresseSuggestions"
                      :key="index"
                      class="flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors border-b border-gray-50 last:border-0"
                      :class="adresseHighlighted === index ? 'bg-red-50' : 'hover:bg-gray-50'"
                      @mousedown.prevent="adresseSelect(item)"
                    >
                      <div class="w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                        <i class="fas fa-map-pin text-gray-400 text-xs"></i>
                      </div>
                      <div class="flex flex-col min-w-0">
                        <span class="text-sm font-semibold text-gray-900 truncate">{{ item._label.split(',')[0] }}</span>
                        <span class="text-xs text-gray-400 truncate">{{ item._label.split(',').slice(1).join(',').trim() }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Séparateur -->
                <div class="flex items-center gap-3">
                  <div class="h-px bg-gray-100 flex-1"></div>
                  <span class="text-xs text-gray-300 font-medium">ou saisir manuellement</span>
                  <div class="h-px bg-gray-100 flex-1"></div>
                </div>

                <!-- Champs manuels -->
                <div class="flex flex-col gap-1.5">
                  <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Rue</label>
                  <input v-model="dataModel.adresse.adresse1" type="text" placeholder="12 rue des Fleurs" class="mf-input" />
                </div>
                <div class="grid grid-cols-2 gap-3">
                  <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Code postal</label>
                    <input v-model="dataModel.adresse.code_postal" type="text" placeholder="69000" maxlength="5" class="mf-input" />
                  </div>
                  <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Ville</label>
                    <input v-model="dataModel.adresse.ville" type="text" placeholder="Lyon" class="mf-input" />
                  </div>
                </div>

                <!-- Badge GPS -->
                <div v-if="dataModel.adresse.latitude" class="flex items-center gap-2 bg-green-50 border border-green-100 rounded-xl px-3.5 py-2.5">
                  <i class="fas fa-location-dot text-green-500 text-xs"></i>
                  <span class="text-xs text-green-700 font-medium">
                    GPS trouvé · {{ Number(dataModel.adresse.latitude).toFixed(4) }}, {{ Number(dataModel.adresse.longitude).toFixed(4) }}
                  </span>
                </div>

                <button
                  class="w-full bg-gray-900 text-white rounded-xl py-3.5 text-sm font-bold border-0 cursor-pointer mt-1 active:bg-gray-700 transition-colors"
                  @click="closeModal"
                >
                  <i class="fas fa-check mr-1.5"></i> Confirmer
                </button>
              </template>

              <!-- ── Appareil ── -->
              <template v-else-if="activeModal === 'appareil'">
                <div v-if="loadingCategories" class="flex justify-center py-6 text-gray-300">
                  <i class="fas fa-spinner fa-spin text-xl"></i>
                </div>
                <div v-else class="flex flex-wrap gap-2">
                  <button
                    v-for="cat in categories" :key="cat.id"
                    class="flex items-center gap-2 px-4 py-2.5 rounded-full border-2 text-sm font-medium cursor-pointer transition-all active:scale-95"
                    :class="dataModel.appareil_type_id === cat.id
                      ? 'border-green-400 bg-green-50 text-green-700'
                      : 'border-gray-200 bg-gray-50 text-gray-600 hover:border-gray-300'"
                    @click="selectCategory(cat)"
                  >
                    <img :src="cat.icon" class="w-5 h-5 object-contain" />
                    {{ cat.label }}
                  </button>
                </div>
              </template>

              <!-- ── Intervention ── -->
              <template v-else-if="activeModal === 'intervention'">
                <div v-if="loadingInterventionTypes" class="flex justify-center py-6 text-gray-300">
                  <i class="fas fa-spinner fa-spin text-xl"></i>
                </div>
                <template v-else>

                  <!-- Un seul type → auto-sélectionné, on affiche juste le nom -->
                  <div v-if="interventionTypes.length === 1" class="flex items-center gap-3 bg-green-50 border border-green-100 rounded-xl px-4 py-3">
                    <i class="fas fa-check-circle text-green-500"></i>
                    <div class="flex flex-col">
                      <span class="text-xs text-green-600 font-medium">Sélectionné automatiquement</span>
                      <span class="text-sm font-semibold text-gray-900">{{ interventionTypes[0].nom }}</span>
                    </div>
                  </div>

                  <!-- Plusieurs types → liste -->
                  <template v-else-if="interventionTypes.length > 1">
                    <button
                      v-for="type in interventionTypes" :key="type.id"
                      class="flex items-center justify-between px-4 py-3.5 rounded-xl border-2 text-left cursor-pointer transition-all active:scale-[0.99] w-full"
                      :class="dataModel.intervention_type_id === type.id
                        ? 'border-green-400 bg-green-50'
                        : 'border-gray-100 bg-gray-50 hover:border-gray-200'"
                      @click="selectInterventionType(type)"
                    >
                      <span class="text-sm font-semibold text-gray-900">{{ type.nom }}</span>
                      <span v-if="type.time_min" class="text-xs text-gray-400 shrink-0 ml-2">
                        <i class="fas fa-clock text-[9px] mr-0.5"></i>{{ formatDuree(type.time_min) }}
                      </span>
                    </button>
                  </template>

                  <!-- Aucun type -->
                  <div v-else class="text-center py-6">
                    <i class="fas fa-info-circle text-gray-300 text-2xl mb-2 block"></i>
                    <span class="text-sm text-gray-400">Aucun type pour cet appareil</span>
                  </div>

                  <!-- Durée ajustable si type sélectionné -->
                  <div v-if="dataModel.intervention_type_id" class="flex items-center gap-3 pt-1 border-t border-gray-50">
                    <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400 shrink-0">Durée</span>
                    <select
                      v-model="dureeHeures"
                      class="flex-1 border border-gray-200 rounded-xl px-3 py-2.5 text-sm bg-gray-50 outline-none text-gray-900"
                      @change="syncDuree"
                    >
                      <option :value="0">0h</option>
                      <option v-for="h in 12" :key="h" :value="h">{{ h }}h</option>
                    </select>
                    <select
                      v-model="dureeMinutes"
                      class="flex-1 border border-gray-200 rounded-xl px-3 py-2.5 text-sm bg-gray-50 outline-none text-gray-900"
                      @change="syncDuree"
                    >
                      <option v-for="m in minutesOptions" :key="m" :value="m">{{ m }}min</option>
                    </select>
                  </div>

                </template>
              </template>

            </div>
          </div>
        </transition>
      </div>
    </transition>

  </div>
</template>

<script>
const LOADING_STEPS = [
  'Lecture du document…',
  'Extraction des données…',
  'Identification du client…',
  'Résolution de l\'adresse…',
  'Finalisation…',
]

const MAPBOX_TOKEN = 'pk.eyJ1IjoidmljdG9yYW53IiwiYSI6ImNrajhuam1iOTZ1dnQydnFqbzRldDJrdW8ifQ.VkIKVhh5_Pcp7PxqQ-GCCg'
const GOUV_URL    = 'https://api-adresse.data.gouv.fr/search/'
const MAPBOX_URL  = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
const TIMEOUT_MS  = 3000

function fetchWithTimeout(url, ms = TIMEOUT_MS) {
  const ctrl  = new AbortController()
  const timer = setTimeout(() => ctrl.abort(), ms)
  return fetch(url, { signal: ctrl.signal }).finally(() => clearTimeout(timer))
}

function emptyClient()  { return { nom: '', prenom: '', telephone: '', email: '' } }
function emptyAdresse() { return { adresse1: '', code_postal: '', ville: '', pays: 'France', latitude: null, longitude: null } }

const MODAL_TITLES = {
  client      : 'Client',
  adresse     : 'Adresse',
  appareil    : 'Type d\'appareil',
  intervention: 'Type d\'intervention',
}

export default {
  name: 'InterventionQuickForm',

  props: {
    dateIntervention : { type: String,  required: true },
    momentDay        : { type: String,  required: true },
    technicienId     : { type: Number,  required: true },
  },

  data() {
    return {
      LOADING_STEPS,

      step           : 'upload',
      documentUrl    : '',
      loadingStep    : '',
      loadingStepIdx : 0,
      loadingTimer   : null,
      scanned        : false,
      filledCount    : 0,
      loadingSubmit  : false,
      activeModal    : null,

      // Adresse autocomplete
      adresseQuery       : '',
      adresseSuggestions : [],
      adresseHighlighted : -1,
      adresseLoading     : false,
      adresseDebounce    : null,

      // Référentiels
      categories               : [],
      interventionTypes        : [],
      loadingCategories        : false,
      loadingInterventionTypes : false,

      // Durée
      dureeHeures   : 0,
      dureeMinutes  : 0,
      minutesOptions: Array.from({ length: 60 }, (_, i) => i),

      dataModel: {
        client               : emptyClient(),
        adresse              : emptyAdresse(),
        appareil_type_id     : null,
        intervention_type_id : null,
        duree_estimee        : null,
        notes_internes       : '',
      },
    }
  },

  computed: {
    hasClient()  { return !!this.dataModel.client.nom?.trim() },
    hasAdresse() { return !!this.dataModel.adresse.adresse1?.trim() },
    canSubmit()  { return this.hasClient },

    selectedCategory() {
      return this.categories.find(c => c.id === this.dataModel.appareil_type_id) || null
    },
    selectedInterventionType() {
      return this.interventionTypes.find(t => t.id === this.dataModel.intervention_type_id) || null
    },
    modalTitle() {
      return MODAL_TITLES[this.activeModal] || ''
    },
  },

  watch: {
    dureeHeures()  { this.syncDuree() },
    dureeMinutes() { this.syncDuree() },
  },

  async mounted() {
    this.loadingCategories = true
    this.categories = await this.$request.post('/reference/get-categories', {}) || []
    this.loadingCategories = false

    await this.loadInterventionTypes()
  },

  methods: {

    // ── Référentiels ────────────────────────────────────────────────

    async loadInterventionTypes() {
      this.loadingInterventionTypes    = true
      this.dataModel.intervention_type_id = null

      const categorie = this.selectedCategory?.key || null

      const results = await this.$request.post('/intervention-types/list', {
        ...(categorie ? { categorie } : {}),
      }) || []

      this.interventionTypes = results

      // Auto-sélection si un seul résultat
      if (results.length === 1) {
        this.selectInterventionType(results[0])
      }

      this.loadingInterventionTypes = false
    },

    // ── Appareil ────────────────────────────────────────────────────

    async selectCategory(cat) {
      this.dataModel.appareil_type_id = cat.id
      this.closeModal()
      await this.loadInterventionTypes()
    },

    // ── Scan ────────────────────────────────────────────────────────

    async onDocumentUploaded(url) {
      if (!url) return
      this.step           = 'scanning'
      this.loadingStepIdx = 0
      this.loadingStep    = LOADING_STEPS[0]
      this.loadingTimer   = setInterval(() => {
        this.loadingStepIdx = Math.min(this.loadingStepIdx + 1, LOADING_STEPS.length - 1)
        this.loadingStep    = LOADING_STEPS[this.loadingStepIdx]
      }, 1600)

      try {
        const result = await this.$request.post('/interventions/init-with-doc', {
          document_url     : url,
          date_intervention: this.dateIntervention,
          moment_day       : this.momentDay,
          technicien_id    : this.technicienId,
        })
        this.applyResult(result)
        this.scanned = true
      } catch {
        this.$toast?.error('Impossible de lire le document')
      } finally {
        clearInterval(this.loadingTimer)
        this.step = 'form'
      }
    },

    async applyResult(res) {
      let filled = 0

      if (res.client?.nom || res.client?.tel) {
        this.dataModel.client = {
          nom      : res.client.nom    || '',
          prenom   : res.client.prenom || '',
          telephone: res.client.tel    || '',
          email    : res.client.email  || '',
        }
        filled++
      }

      if (res.adresse?.adresse1 || res.adresse?.ville) {
        this.dataModel.adresse = { ...emptyAdresse(), ...res.adresse }
        this.adresseQuery = [res.adresse.adresse1, res.adresse.code_postal, res.adresse.ville].filter(Boolean).join(', ')
        filled++
      }

      if (res.appareil_type_id) {
        this.dataModel.appareil_type_id = res.appareil_type_id
        filled++
        // Recharger les types d'intervention avec la catégorie de l'appareil trouvé
        await this.loadInterventionTypes()
      }

      if (res.intervention_type_id && this.interventionTypes.length !== 1) {
        this.dataModel.intervention_type_id = res.intervention_type_id
        const matched = this.interventionTypes.find(t => t.id === res.intervention_type_id)
        if (matched?.time_min) this.setDureeFromMinutes(matched.time_min)
        filled++
      } else if (this.dataModel.intervention_type_id) {
        // Auto-sélectionné via loadInterventionTypes
        filled++
      }

      if (res.notes_internes) {
        this.dataModel.notes_internes = res.notes_internes
        filled++
      }

      this.filledCount = filled
    },

    // ── Modale ──────────────────────────────────────────────────────

    openModal(target) { this.activeModal = target },
    closeModal()      { this.activeModal = null; this.adresseSuggestions = [] },

    // ── Adresse autocomplete ─────────────────────────────────────────

    onAdresseInput() {
      this.adresseHighlighted = -1
      clearTimeout(this.adresseDebounce)
      if (!this.adresseQuery || this.adresseQuery.length < 3) {
        this.adresseSuggestions = []
        return
      }
      this.adresseDebounce = setTimeout(() => this.adresseSearch(), 300)
    },

    async adresseSearch() {
      this.adresseLoading     = true
      this.adresseSuggestions = []
      try {
        const gouvResults = await this.searchGouv(this.adresseQuery)
        if (gouvResults.length) {
          this.adresseSuggestions = gouvResults
          this.adresseHighlighted = 0
          return
        }
        const mapboxResults = await this.searchMapbox(this.adresseQuery)
        this.adresseSuggestions = mapboxResults
        this.adresseHighlighted = mapboxResults.length ? 0 : -1
      } catch {
        this.adresseSuggestions = []
      } finally {
        this.adresseLoading = false
      }
    },

    async searchGouv(q) {
      const url = `${GOUV_URL}?q=${encodeURIComponent(q)}&limit=5&type=housenumber`
      const res = await fetchWithTimeout(url)
      if (!res.ok) throw new Error('gouv_error')
      const data = await res.json()
      return (data.features || []).map(f => ({
        _source: 'gouv',
        _label : f.properties.label,
        _props : f.properties,
        _coords: f.geometry.coordinates,
      }))
    },

    async searchMapbox(q) {
      const url = `${MAPBOX_URL}${encodeURIComponent(q)}.json?autocomplete=true&limit=5&country=fr&types=address&access_token=${MAPBOX_TOKEN}`
      const res = await fetchWithTimeout(url)
      if (!res.ok) throw new Error('mapbox_error')
      const data = await res.json()
      return (data.features || []).map(f => ({
        _source: 'mapbox',
        _label : f.place_name,
        _raw   : f,
      }))
    },

    adresseSelect(item) {
      if (item._source === 'gouv') {
        const p = item._props
        this.dataModel.adresse.adresse1    = p.name
        this.dataModel.adresse.code_postal = p.postcode
        this.dataModel.adresse.ville       = p.city
        this.dataModel.adresse.pays        = 'France'
        this.dataModel.adresse.longitude   = item._coords[0]
        this.dataModel.adresse.latitude    = item._coords[1]
      } else {
        const f   = item._raw
        const ctx = f.context || []
        this.dataModel.adresse.adresse1    = f.address ? `${f.address} ${f.text}` : f.place_name
        this.dataModel.adresse.code_postal = ctx.find(c => c.id.includes('postcode'))?.text || ''
        this.dataModel.adresse.ville       = ctx.find(c => c.id.includes('place'))?.text    || ''
        this.dataModel.adresse.pays        = ctx.find(c => c.id.includes('country'))?.text  || 'France'
        this.dataModel.adresse.longitude   = f.center[0]
        this.dataModel.adresse.latitude    = f.center[1]
      }
      this.adresseQuery       = item._label
      this.adresseSuggestions = []
      this.adresseHighlighted = -1
    },

    adresseMoveDown() {
      this.adresseHighlighted = Math.min(this.adresseHighlighted + 1, this.adresseSuggestions.length - 1)
    },
    adresseMoveUp() {
      this.adresseHighlighted = Math.max(this.adresseHighlighted - 1, 0)
    },
    adresseSelectHighlighted() {
      if (this.adresseHighlighted >= 0) this.adresseSelect(this.adresseSuggestions[this.adresseHighlighted])
    },

    // ── Intervention ─────────────────────────────────────────────────

    selectInterventionType(type) {
      this.dataModel.intervention_type_id = type.id
      if (type.time_min) this.setDureeFromMinutes(type.time_min)
    },

    // ── Durée ───────────────────────────────────────────────────────

    setDureeFromMinutes(total) {
      this.dureeHeures  = Math.floor(total / 60)
      this.dureeMinutes = total % 60
      this.syncDuree()
    },

    syncDuree() {
      this.dataModel.duree_estimee = (Number(this.dureeHeures) * 60) + Number(this.dureeMinutes)
    },

    formatDuree(min) {
      const h = Math.floor(min / 60), m = min % 60
      if (h && m) return `${h}h${m}`
      return h ? `${h}h` : `${m}min`
    },

    // ── Reset ────────────────────────────────────────────────────────

    resetScan() {
      clearInterval(this.loadingTimer)
      this.scanned      = false
      this.filledCount  = 0
      this.documentUrl  = ''
      this.adresseQuery = ''
      this.dataModel    = { client: emptyClient(), adresse: emptyAdresse(), appareil_type_id: null, intervention_type_id: null, duree_estimee: null, notes_internes: '' }
      this.dureeHeures  = 0
      this.dureeMinutes = 0
      this.step         = 'upload'
    },

    // ── Submit ───────────────────────────────────────────────────────

    async submit() {
      if (!this.canSubmit) return
      this.loadingSubmit = true
      try {
        const res = await this.$request.post('/interventions/create-from-json', {
          date_intervention: this.dateIntervention,
          moment_day       : this.momentDay,
          technicien_id    : this.technicienId,
          ...this.dataModel,
        })
        this.$emit('created', res)
      } catch {
        this.$toast?.error('Erreur lors de la création')
      } finally {
        this.loadingSubmit = false
      }
    },
  },
}
</script>

<style scoped>
.mf-input {
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  padding: 11px 14px;
  font-size: 14px;
  background: #f9fafb;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  color: #111827;
  transition: border-color 0.15s, background 0.15s;
  font-family: inherit;
}
.mf-input:focus       { border-color: #f87171; background: #fff; }
.mf-input::placeholder { color: #d1d5db; }
.mf-input.pl-10       { padding-left: 2.5rem; }
</style>